import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import icons from "../../../assets/images/constantIcons";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import toast from "react-hot-toast";

const Security = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object({
    current_password: Yup.string().required("Current password is required"),
    new_password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/\d/, "Password must contain at least one number")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one special character"
      )
      .required("New Password is required"),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("new_password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const formik = useFormik({
    initialValues: {
      current_password: "",
      new_password: "",
      confirm_password: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const payload = {
          current_password: values.current_password,
          new_password: values.new_password,
          confirm_password: values.confirm_password,
        }
        const response = await apiService.patch(`/vendors/change_password`, payload);
        toast.success(response.message, { duration: 2000 });
        formik.resetForm();
      } catch (errors) {
        handleError(errors);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="bg-white rounded-2xl shadow-md w-full mt-6 flex justify-center">
      <div className="flex flex-col items-center  my-5 md:my-8 w-[300px] xs:w-[400px] px-4 bg-white">
        <form onSubmit={formik.handleSubmit} className="w-full max-w-md flex flex-col gap-4">
          {/* Current Password */}
          <div className="relative text-G300">
            <label className="block text-sm mb-2">Current Password</label>
            <input
              type={showCurrentPassword ? "text" : "password"}
              name="current_password"
              value={formik.values.current_password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="inputtext"
              placeholder="*********"
              autoComplete="current_password"
            />
            <button
              type="button"
              className="absolute right-3 top-10 text-green"
              onClick={() => setShowCurrentPassword(!showCurrentPassword)}
            >
              {showCurrentPassword ? <icons.FaEye /> : <icons.FaEyeSlash />}
            </button>
            {formik.touched.current_password && formik.errors.current_password && (
              <p className="text-red text-sm mt-1">{formik.errors.current_password}</p>
            )}
          </div>

          {/* New Password */}
          <div className="relative text-G300">
            <label className="block text-sm mb-2">New Password</label>
            <input
              type={showPassword ? "text" : "password"}
              name="new_password"
              value={formik.values.new_password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="inputtext"
              placeholder="*********"
              autoComplete="new_password"

            />
            <button
              type="button"
              className="absolute right-3 top-10 text-green"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <icons.FaEye /> : <icons.FaEyeSlash />}
            </button>
            {formik.touched.new_password && formik.errors.new_password && (
              <p className="text-red text-sm mt-1">{formik.errors.new_password}</p>
            )}
          </div>

          {/* Confirm Password */}
          <div className="relative text-G300">
            <label className="block text-sm mb-2">Confirm Password</label>
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirm_password"
              value={formik.values.confirm_password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="inputtext"
              placeholder="*********"
              autoComplete="confirm_password"

            />
            <button
              type="button"
              className="absolute right-3 top-10 text-green"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? <icons.FaEye /> : <icons.FaEyeSlash />}
            </button>
            {formik.touched.confirm_password && formik.errors.confirm_password && (
              <p className="text-red text-sm mt-1">{formik.errors.confirm_password}</p>
            )}
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className={`w-full text-sm bg-green text-white py-2 rounded-lg mt-5 ${loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            disabled={loading}
          >
            {loading ? "Updating..." : "Change Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Security;
